<div class="mainContainer fieldMain">
  <div class="overlay"></div>
  <!-- <div class="sidePanel">
     <div class="logoSec">
        <a href="#" class="logo"><span class="logoImg"><img src="assets/img/logo.png" alt=""></span><span class="logoText"><img src="assets/img/logoText.png" alt=""></span></a>
     </div>
     
     <ul class="helpSec">
     
        <li class="profile">
           <a href="#">
            <span class="icon">
              <img *ngIf="!profilePic" src="assets/img/default.jpg" alt="">
              <img *ngIf="profilePic" src="{{imageViewUrl}}{{profilePic}}" alt="">

          </span>
          <span class="text">{{userName | slice:0:11}}
              <span *ngIf="userName && userName.length >11">...</span>
          </span>

              <span class="helpArrow">
                <i class="material-icons">keyboard_arrow_right</i>
              </span>
            </a>
           <div class="subNav singleSubNav">
              <ul class="subNavList">
                  <li><a href="#" data-toggle="modal" data-target="#profileViewModal"><i class="material-icons-outlined">perm_identity</i>Profile</a></li>
                        <li [routerLink]="['/home/user/feedback']" routerLinkActive="active"><a href="#"><i class="material-icons-outlined">feedback</i>Feedback</a></li>
              
                 <li (click)="toLogin();"><a href="#"><i class="material-icons-outlined">power_settings_new</i>Logout</a></li>
              </ul>
           </div>
        </li>
     </ul>
  </div> -->
  <div class="mainPanel reportMainPanel clientMainPanel">
     <div class="midPanel">
        <div class="fullPanel">
           <div class="breadcrumbSec">
              <a id="naviconLeft" href="#" class="navicon"><img src="assets/img/hamburgerIcon.png" alt=""></a>
              <div class="breadcrumbText">
                 <p><a href="#">Home</a> </p>
              </div>
           </div>
           <div class="fieldUserContainer mCustomScrollbar" data-mcs-theme="minimal-dark">
             <div class="midDiv">
             <h1>You are a <strong>Field User</strong>. You automatically get access to the <strong>Workmate mobile application</strong>..</h1>
             <p>Please download the Workmate mobile app.</p>
             <ul class="appList" [hidden]="inAppOsType">
               <li>
                  <a href="https://play.google.com/store/apps/details?id=com.mmi.workmate&hl=en_IN" target="_blank">
                     <img src="assets/img/app_img01.png" alt="">
                  </a>
               </li>
               <li>
                  <a href="https://apps.apple.com/in/app/mapmyindia-workmate/id1342209376" target="_blank">
                     <img src="assets/img/app_img02.png" alt="">
                  </a>
               </li>
             </ul>

             <ul class="appList"  [hidden]="!inAppOsType">
               <li  [hidden]="inAppOsType != inAppOsTypeMap.ANDROID">
                  <a href="market://details?id=com.mmi.workmate" target="_blank">
                     <img  src="assets/img/app_img01.png" alt="">
                  </a>
               </li>
               <li  [hidden]="inAppOsType != inAppOsTypeMap.IOS">
                  <a href="itms-apps://itunes.apple.com/app/apple-store/id1342209376" target="_blank">
                     <img  src="assets/img/app_img02.png" alt="">
                  </a>
               </li>
             </ul>
             <div class="mobImg"><img src="assets/img/mob01.png" alt=""></div>
             <h3><strong>Work Easy</strong> with <strong>Workmate</strong></h3>
             </div>

             <div class="mobAppSec">
               <h4>With the Workmate mobile app you can:</h4>
               <div class="navDiv">
                                   
                                <ul class="nav nav-pills scroll-touch">
                                   <li (click)="stopNavigation(1)"><a [ngClass]="count==1 ? 'active' : ''" data-toggle="pill" href="#home">Mark your attendance</a></li>
                                   <li (click)="stopNavigation(2)"><a [ngClass]="count==2 ? 'active' : ''" data-toggle="pill" href="#menu1">Capture odometer reading</a></li>
                                   <li (click)="stopNavigation(3)"><a [ngClass]="count==3 ? 'active' : ''" data-toggle="pill" href="#menu2">Claim your reimbursement</a></li>
                                   <li (click)="stopNavigation(4)"><a [ngClass]="count==4 ? 'active' : ''" data-toggle="pill" href="#menu3">Navigate to a customer location </a></li>
                                   <li (click)="stopNavigation(5)"><a [ngClass]="count==5 ? 'active' : ''" data-toggle="pill" href="#menu4">Live Location Tracking</a></li>
                                   <li (click)="stopNavigation(6)"><a [ngClass]="count==6 ? 'active' : ''" data-toggle="pill" href="#menu5">Perform task at customer location</a></li>                                          
                                </ul>
                             </div>
                             <div class="tab-content">
                                <div id="home" class="tab-pane fade in active" (mouseover)="pauseInterval()" (mouseout)="startInterval()">
                                  <div class="stepImg"><img src="assets/img/appImg{{count}}.png" alt=""></div>
                                </div>
                             
                             </div>
             </div>
           </div>
        </div>
      
     </div>
  </div>
</div>

<!-- <div class="mainContainer fieldmainContainer">
    
    <div class="mainPanel reportMainPanel clientMainPanel">
       <div class="midPanel">
          <div class="fullPanel">

             <div class="mobtaskBtn dropup dropdown customDropdown">
                 <a href="#" data-toggle="dropdown" class="taskAddBtn dropdown-toggle" (click)="toLogin();">
                     <i class="material-icons">person</i>
                </a>
                
            </div>
             <div class="fieldUserContainer mCustomScrollbar" data-mcs-theme="minimal-dark">
               <div class="midDiv">
               <h1>You are a <strong>Field User</strong>. You automatically get access to the <strong>Workmate mobile application</strong>..</h1>
               <p>Please download the Workmate mobile app.</p>
               <ul class="appList">
                 <li><a href="#"><img src="assets/img/app_img01.png" alt=""></a></li>
                 <li><a href="#"><img src="assets/img/app_img02.png" alt=""></a></li>
               </ul>
               <div class="mobImg"><img src="assets/img/mob01.png" alt=""></div>
               <h3><strong>Work Easy</strong> with <strong>Workmate</strong></h3>
               </div>

               <div class="mobAppSec">
                 <h4>With the Workmate mobile app you can:</h4>
                 <div class="navDiv">
                                     
                                  <ul class="nav nav-pills scroll-touch">
                                     <li><a data-toggle="pill" href="#home" class="active">Mark your attendance</a></li>
                                     <li><a data-toggle="pill" href="#menu1">Capture odometer reading</a></li>
                                     <li><a data-toggle="pill" href="#menu2">Claim your reimbursement</a></li>
                                     <li><a data-toggle="pill" href="#menu3">Navigate to a customer location </a></li>
                                     <li><a data-toggle="pill" href="#menu4">Live Location Tracking</a></li>
                                     <li><a data-toggle="pill" href="#menu5">Perform task at customer location</a></li>                                          
                                  </ul>
                               </div>
                               <div class="tab-content">
                                  <div id="home" class="tab-pane fade in active">
                                    <div class="stepImg"><img src="assets/img/appImg1.png" alt=""></div>
                                  </div>
                                  <div id="menu1" class="tab-pane fade">
                                    <div class="stepImg"><img src="assets/img/appImg2.png" alt=""></div>
                                  </div>
                                  <div id="menu2" class="tab-pane fade">
                                    <div class="stepImg"><img src="assets/img/appImg3.png" alt=""></div>
                                  </div>
                                  <div id="menu3" class="tab-pane fade">
                                    <div class="stepImg"><img src="assets/img/appImg4.png" alt=""></div>
                                  </div>
                                  <div id="menu4" class="tab-pane fade">
                                    <div class="stepImg"><img src="assets/img/appImg5.png" alt=""></div>
                                  </div>
                                  <div id="menu5" class="tab-pane fade">
                                    <div class="stepImg"><img src="assets/img/appImg6.png" alt=""></div>
                                  </div>
                               </div>
               </div>
             </div>
          </div>
        
       </div>
    </div>
 </div> -->


<!-- <button (click)="toLogin();">Back to Login</button> -->